module.exports = __webpack_public_path__ + "static/media/Placeholder.849c29fe.webp";